import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {Step, StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ModeratRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {VerbrauchsanalyseStepVerbrauchsdatenComponent} from "../../verbrauchsanalyse/verbrauchsanalyse.step.verbrauchsdaten.component";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {VerbrauchsanalyseModeratForm} from "./verbrauchsanalyse.moderat.form";
import {StepNavigationElement} from "../../step/step.navigation.element";
import {WpcheckStartComponent} from "../wpcheck/wpcheck.start.component";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";

/**
 * Custom step for the input of invoices on the step "verbrauchsdaten"
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-verbrauchsanalyse-moderat-verbrauchsdaten',
    templateUrl: '../../verbrauchsanalyse/verbrauchsanalyse.step.verbrauchsdaten.component.html',
    standalone: false
})
export class VerbrauchsanalyseModeratStepVerbrauchsdatenComponent extends VerbrauchsanalyseStepVerbrauchsdatenComponent implements OnInit{
  /**
   * (input) data of the user
   */
  anfrage: ModeratAnfrage;

  /**
   * @inheritDoc
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: ModeratRequestService, protected elementService: ElementService,
              protected portalService: PortalService, protected energyMapService: EnergyMapService) {
    super(stepService, router, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in these steps and init the parent form
    this.formConfig = new VerbrauchsanalyseModeratForm(this.energyMapService);

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    super.ngOnInit();

    // special case, last step on wpcheck chapter
    if (this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK && this.steps.nextStep === null) {
      this.steps.nextStep = new Step('wpcheckergebnis', '/moderat/wpcheckergebnis/massnahmen');
    }

    // preset data
    this.formConfig.setData(this.anfrage.verbrauchsanalyseInput);

    // init the invoices
    this.initInvoices();

    // url for the first step
    this.entryUrl = this.portalService.currentPortalId + '/moderat';

    this.textkeyPrefix = 'moderat';

    // update the previous step
    this.onStepUpdate();

    // show navigation element back to the wpcheck
    if(this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK) {
      this.stepService.setNavigationPreElement(
        new StepNavigationElement('moderat.nav.wpcheck.', true, WpcheckStartComponent.wpcheckUrl.replace('{{portalId}}', this.portalService.currentPortalId))
      );
    }
  }

  /**
   * @inheritDoc
   */
  moveToNextStep() {
    if (this.anfrage.mode === ModeratAnfrage.MODE_WPCHECK && this.steps.nextStep.name === 'wpcheckergebnis') {
      this.moved = true;
      // move on to the next step
      this.router.navigateByUrl(this.portalService.currentPortalId + this.steps.nextStep.path);
    }
    else {
      super.moveToNextStep();
    }
  }
}
